"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dayjs_1 = __importDefault(require("dayjs"));
var react_router_dom_1 = require("react-router-dom");
var config_1 = __importDefault(require("config"));
var UserStore_1 = require("stores/UserStore");
var QueriesStore_1 = require("stores/QueriesStore");
var InfoRow_1 = __importDefault(require("components/core/common/InfoRow"));
var TextInput_1 = __importDefault(require("components/core/inputs/TextInput"));
var Select_1 = __importDefault(require("components/core/inputs/Select"));
var use_stores_1 = require("../../../../../hooks/use-stores");
var Button_1 = __importDefault(require("../../../../core/buttons/Button"));
var FileInput_1 = __importDefault(require("../../../../core/inputs/FileInput"));
var api_1 = __importDefault(require("api"));
var Notification_1 = require("../../../../core/Notification");
var use_notification_1 = require("../../../../../hooks/use-notification");
var Loading_1 = __importDefault(require("../../../../core/Loading"));
var Dialog_1 = require("../../../../core/Dialog");
var use_dialog_1 = require("../../../../../hooks/use-dialog");
var getCurrency = function (country) {
    return country === QueriesStore_1.Countries.IR ? "€" : "£";
};
var toBoolean = function (input) { return input === "true"; };
var QueryDetailsStage1 = function (_a) {
    var data = _a.data;
    var _b = react_1.useState(null), attachments = _b[0], setAttachments = _b[1];
    var _c = react_1.useState(false), busy = _c[0], setBusy = _c[1];
    var _d = use_stores_1.useStores(), userStore = _d.userStore, queriesStore = _d.queriesStore;
    var notification = use_notification_1.useNotification();
    var history = react_router_dom_1.useHistory();
    var dialog = use_dialog_1.useDialog();
    var timeoutRef = react_1.useRef(null);
    var changeHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        if (value === "true" || value === "false")
            value = toBoolean(value);
        api_1.default.patchQuery(data.id, (_a = {},
            _a[e.currentTarget.name] = value,
            _a))
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var changeTextHandler = function (e) {
        var _a;
        var value = e.currentTarget.value;
        clearTimeout(timeoutRef.current);
        var dataObject = (_a = {},
            _a[e.currentTarget.name] = value,
            _a);
        timeoutRef.current = setTimeout(function () { return api_1.default.patchQuery(data.id, dataObject)
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Query updated"
            });
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        }); }, 1500);
    };
    var fileErrorHandler = function (error) {
        notification({
            variant: Notification_1.NotificationVariants.ERROR,
            message: error
        });
    };
    var fileSelectHandler = function (name, fileList) {
        setAttachments(fileList);
    };
    var uploadHandler = function (e) {
        if (attachments.length <= 0) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Please select a file"
            });
        }
        setBusy(true);
        var formData = new FormData();
        formData.append("query", data.id.toString());
        for (var i = 0; i < attachments.length; i++) {
            formData.append("attachments[]", attachments[i]);
        }
        api_1.default.postAttachment(formData)
            .then(function (response) {
            queriesStore.editDataItem(response.data);
            notification({
                variant: Notification_1.NotificationVariants.SUCCESS,
                message: "Attachment uploaded"
            });
            setBusy(false);
            setAttachments(null);
        }, function (error) {
            notification({
                variant: Notification_1.NotificationVariants.ERROR,
                message: "Error updating query"
            });
        });
    };
    var closeHandler = function () {
        dialog({
            variant: Dialog_1.DialogVariants.CONFIRMATION,
            title: "Close this query?",
            description: "Are you sure you want to close this query? Please make sure are ok for this query to be closed and leave your comments below to explain the reason for this closure.",
            withComment: true,
            queryId: data.id,
            stage: data.currentStage,
            direction: "Forward"
        })
            .then(function (response) {
            api_1.default.closeQuery(data.id, { currentStage: 2 })
                .then(function (response) {
                notification({
                    variant: Notification_1.NotificationVariants.SUCCESS,
                    message: "Query closed!"
                });
                queriesStore.editDataItem(response.data);
                setTimeout(function () {
                    history.replace("/");
                }, 1000);
            }, function (error) {
                notification({
                    variant: Notification_1.NotificationVariants.ERROR,
                    message: "Query could not be closed due to an error"
                });
            });
        });
    };
    var getDuplicateLogNo = function (id) {
        for (var _i = 0, _a = queriesStore.data; _i < _a.length; _i++) {
            var query = _a[_i];
            if (query.id === id) {
                return query.logNumber;
            }
        }
    };
    return (react_1.default.createElement("div", { className: "query-stage query-stage-1" },
        react_1.default.createElement("span", { className: "title" }, "Stage 1"),
        react_1.default.createElement("div", { className: "flex flex-row" },
            react_1.default.createElement("div", { className: "half" },
                react_1.default.createElement(InfoRow_1.default, { label: "Log No", value: data.logNumber }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser === null && !userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ? react_1.default.createElement(InfoRow_1.default, { label: "Query Received", value: dayjs_1.default(data.initialQueryDate).format("YYYY-MM-DD") })
                    :
                        (data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
                            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.activeUser === null && userStore.hasPermission(UserStore_1.Permissions.STAGE_1) || (data.activeUser !== null && data.activeUser.username === userStore.data.username)) ?
                            react_1.default.createElement(TextInput_1.default, { type: "date", name: "initialQueryDate", value: data !== null && dayjs_1.default(data.initialQueryDate).format("YYYY-MM-DD") || null, onChange: changeHandler })
                            :
                                react_1.default.createElement(InfoRow_1.default, { label: "Query Received", value: dayjs_1.default(data.initialQueryDate).format("YYYY-MM-DD") }),
                react_1.default.createElement(InfoRow_1.default, { label: "Date Logged", value: dayjs_1.default(data.createdAt).format("DD/MM/YYYY") }),
                react_1.default.createElement(InfoRow_1.default, { label: "Query Type", value: data.queryType.name }),
                react_1.default.createElement(InfoRow_1.default, { label: "Requested By", value: data.user.fullName }),
                data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser === null && !userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ? data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
                    react_1.default.createElement(InfoRow_1.default, { label: "Product Type", value: data.priceQuery && data.priceQuery.productType })
                    :
                        (data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
                            data.currentStage <= 2 &&
                            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.activeUser === null && userStore.hasPermission(UserStore_1.Permissions.STAGE_1) || (data.activeUser !== null && data.activeUser.username === userStore.data.username && data.queryType.id === QueriesStore_1.QueryTypes.PRICE)) ?
                            react_1.default.createElement(Select_1.default, { name: "productType", value: data !== null && data.priceQuery.productType || "", options: Object.keys(QueriesStore_1.ProductTypes).map(function (type) { return ({
                                    value: QueriesStore_1.ProductTypes[type],
                                    text: QueriesStore_1.ProductTypes[type]
                                }); }), onChange: changeHandler })
                            :
                                data.queryType.id === QueriesStore_1.QueryTypes.PRICE &&
                                    react_1.default.createElement(InfoRow_1.default, { label: "Product Type", value: data.priceQuery && data.priceQuery.productType }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "billingRef", value: data !== null && data.podQuery.billingRef || "", onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Billing Ref", value: data.podQuery.billingRef }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "deliveryRef", value: data !== null && data.podQuery.deliveryRef || "", onChange: changeHandler, duplicate: data.podQuery.duplicateRef === true ? getDuplicateLogNo(data.podQuery.duplicateRefId) : null })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Delivery Ref", value: data.podQuery.deliveryRef, duplicate: data.podQuery.duplicateRef === true ? getDuplicateLogNo(data.podQuery.duplicateRefId) : null }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "deliveryDate", value: data !== null && dayjs_1.default(data.podQuery.deliveryDate).format("YYYY-MM-DD") || null, onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Delivery Date", value: dayjs_1.default(data.podQuery.deliveryDate).format("DD/MM/YYYY") })),
            react_1.default.createElement("div", { className: "half" },
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser === null && !userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ?
                    react_1.default.createElement(InfoRow_1.default, { label: "Country", value: data.country })
                    :
                        data.currentStage <= 2 &&
                            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.activeUser === null && userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ||
                            data.currentStage <= 2 &&
                                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                                data.activeUser.username === userStore.data.username ?
                            react_1.default.createElement(Select_1.default, { name: "country", value: data !== null && data.country, options: [
                                    { value: QueriesStore_1.Countries.UK, text: "United Kingdom" },
                                    { value: QueriesStore_1.Countries.IR, text: "Ireland" }
                                ], onChange: changeHandler })
                            :
                                react_1.default.createElement(InfoRow_1.default, { label: "Country", value: data.country }),
                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser === null && !userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ?
                    react_1.default.createElement(InfoRow_1.default, { label: "A/C Number", value: data.acNumber })
                    :
                        data.currentStage <= 2 &&
                            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                            data.activeUser === null && userStore.hasPermission(UserStore_1.Permissions.STAGE_1) ||
                            data.currentStage <= 2 &&
                                data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                                data.activeUser.username === userStore.data.username ?
                            react_1.default.createElement(TextInput_1.default, { type: "text", name: "acNumber", defaultValue: data !== null && data.acNumber, onChange: changeTextHandler })
                            :
                                react_1.default.createElement(InfoRow_1.default, { label: "A/C Number", value: data.acNumber }),
                react_1.default.createElement(InfoRow_1.default, { label: "Customer Name", value: data.customer }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "invoiceRef", value: data !== null && data.podQuery.invoiceRef || "", onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Invoice Ref", value: data.podQuery.invoiceRef }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "text", name: "salesOrderRef", value: data !== null && data.podQuery.salesOrderRef || "", onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Sales Order Ref", value: data.podQuery.salesOrderRef }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "date", name: "dueDate", value: data !== null && dayjs_1.default(data.dueDate).format("YYYY-MM-DD") || null, onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Due Date", value: dayjs_1.default(data.dueDate).format("DD/MM/YYYY") }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(TextInput_1.default, { type: "number", step: 0.1, placeholder: "Total Invoice Value", name: "totalInvoiceValue", defaultValue: data.totalInvoiceValue === null ? "" : data.totalInvoiceValue, onChange: changeTextHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Total Invoice(s) Value", value: data.totalInvoiceValue === null ? "" : parseFloat(data.totalInvoiceValue).toFixed(2) }),
                data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                    data.currentStage <= 2 &&
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                    data.activeUser.username === userStore.data.username ||
                    data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                        data.currentStage <= 2 &&
                        userStore.hasPermission(UserStore_1.Permissions.STAGE_2) ?
                    react_1.default.createElement(Select_1.default, { name: "queryReason", value: data !== null && data.podQuery.queryReason || "", options: Object.keys(QueriesStore_1.PODQueryReasons).map(function (type) { return ({
                            value: QueriesStore_1.PODQueryReasons[type],
                            text: QueriesStore_1.PODQueryReasons[type]
                        }); }), onChange: changeHandler })
                    :
                        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
                            react_1.default.createElement(InfoRow_1.default, { label: "Query Reason", value: data.podQuery && data.podQuery.queryReason }))),
        react_1.default.createElement("div", { className: "attachments" },
            react_1.default.createElement("span", { className: "subtitle" }, "Attachments"),
            react_1.default.createElement("ul", null, data.attachments.length <= 0 ?
                react_1.default.createElement("p", null, "There are no attachments")
                :
                    data.attachments.map(function (attachment) { return (react_1.default.createElement("li", { key: attachment.id },
                        react_1.default.createElement("a", { href: config_1.default.api_base + "/attachment/" + attachment.id, title: attachment.fileName }, attachment.fileName))); })),
            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
                data.currentStage <= 3 &&
                react_1.default.createElement("div", null,
                    react_1.default.createElement(FileInput_1.default, { name: "newAttachment", files: attachments, onFileError: fileErrorHandler, onFileSelect: fileSelectHandler }),
                    react_1.default.createElement(Button_1.default, { type: "button", title: "Upload", icon: busy && react_1.default.createElement(Loading_1.default, null) || null, onClick: uploadHandler }, "Upload"))),
        data.queryType.id === QueriesStore_1.QueryTypes.POD &&
            data.status === QueriesStore_1.QueryStatus.ACTIVE &&
            data.queryStage.stage === 1 &&
            userStore.hasPermission(UserStore_1.Permissions.STAGE_1) &&
            react_1.default.createElement(Button_1.default, { className: "button close-button", type: "button", onClick: closeHandler, title: "Close Query" }, "Close Query")));
};
exports.default = QueryDetailsStage1;
